// extracted by mini-css-extract-plugin
export default {"addGroupContainer":"AddGroup_addGroupContainer__XxiNt","customSelectNew":"AddGroup_customSelectNew__5nnoW","inputsContainer":"AddGroup_inputsContainer__oREV+"};